module.exports = __webpack_public_path__ + "60f1fa42c6b910f36f6708e8691e9a73.svg";